var View = require('views/base/view');

var CssView = View.extend({
  autoRender: true,
  autoAttach: true,
  noWrap: true,
  initialize: function(options) {
    this.template = options.template;
    View.prototype.initialize.apply(this, arguments);
  },
  getTemplateFunction() {
    return require(this.template);
  }
});

module.exports = CssView;